import React from 'react';

export const Footer = () => <footer>&copy; JIW 2023</footer>;
